import WordpressHttpClient from 'js-promo-partners-lib/lib/services/wordpress/wordpress-http-client/wordpress-http-client';

class PluginHttptClient extends WordpressHttpClient {
    onRefreshNonce () {
        // in order to create a new nonce inside the plugin,
        // we only need to refresh the page
        window.location.reload();
    }
}

export default PluginHttptClient;
